import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

const DropdownSelect = ({ formControl, value, onChange, name, id, label, options }) => {
  return (
    <FormControl className={formControl}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        inputProps={{
          name: name,
          id: id,
        }}
      >
        {options?.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropdownSelect;
